import React, { useState } from 'react';
import { Box, Card } from '@mui/material';
import { DialogForm, IDialogActions } from '../../../shared/components';
import { useTheme } from '@mui/material/styles';
import { TestExecution } from './TestExecution';

interface ITestExecutionListViewDialogProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: true) => void;
}

export const TestExecutionListViewDialog: React.FC<ITestExecutionListViewDialogProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [loading, setLoading] = useState(false);

    const theme = useTheme();

    const actions: IDialogActions[] = [
        { id: 'close', text: 'Close', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];
    return (
        <React.Fragment>
            <DialogForm
                title='TEST EXECUTION LIST VIEW'
                icon='playlist_add_check_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Card sx={{ bgcolor: theme.palette.background.default, p: 1, width: '100%' }}>
                        <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                            <TestExecution
                                data={data}
                                testScenarioId={parentId}
                            />
                        </Box>
                    </Card>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};